import { useGetConclusionQuery } from "../conclusionsSlice";
import useRefresher from "../../../hooks/useRefresher";

const useConclusion = ({ id }) => {
  const conclusion = useGetConclusionQuery({ id }, { skip: id == null });
  useRefresher(conclusion);

  return conclusion;
};

export default useConclusion;
